import React from 'react';

function PlaceholderDefaultIcon(props) {
  return (
    <svg
      width="420"
      height="420"
      viewBox="0 0 420 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M364.828 86.278C362.28 88.1159 359.14 84.9766 360.978 82.4278L375.378 62.4588C377.823 59.0686 382.712 58.6612 385.654 61.6027C388.595 64.5442 388.188 69.4337 384.797 71.8784L364.828 86.278Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M364.038 97.7495C361.798 97.3847 361.798 94.1627 364.038 93.7979L381.588 90.9399C384.568 90.4547 387.273 92.7547 387.273 95.7737C387.273 98.7927 384.568 101.093 381.588 100.608L364.038 97.7495Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M348.54 84.6448C348.832 86.4372 351.41 86.4372 351.702 84.6448L353.989 70.6014C354.377 68.2171 352.537 66.0527 350.121 66.0527C347.706 66.0527 345.865 68.2171 346.254 70.6013L348.54 84.6448Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M337.897 314.505L339.493 287.271C334.833 286.348 330.369 284.792 326.174 282.685C325.718 282.795 325.235 282.853 324.729 282.853L310.468 282.853V309.217C310.468 315.844 305.096 321.217 298.468 321.217H201.48L87.8864 321.217C118.069 354.411 161.601 375.25 210 375.25C261.585 375.25 307.64 351.578 337.897 314.505Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M349.5 135.25C352.254 135.25 354.962 135.664 357.612 136.442C330.522 82.3696 274.596 45.25 210 45.25C150.793 45.25 98.8701 76.4341 69.7589 123.274C73.981 128.633 76.5 135.398 76.5 142.75C76.5 158.794 64.5057 172.036 48.9949 173.999C46.3798 185.664 45 197.796 45 210.25C45 223.458 46.5519 236.304 49.4834 248.614L113.834 171.272L113.821 171.25H239.351C242.924 171.25 246.311 172.842 248.59 175.592L292.623 228.716C292.541 227.322 292.5 225.917 292.5 224.5C292.5 189.292 318.02 135.25 349.5 135.25Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M359.51 287.271C356.261 287.914 352.916 288.25 349.502 288.25C346.087 288.25 342.742 287.914 339.493 287.271L337.874 314.899C337.672 318.345 340.412 321.25 343.863 321.25H355.14C358.591 321.25 361.331 318.345 361.129 314.899L359.51 287.271Z"
        fill="black"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M349.5 288.25C380.98 288.25 406.5 259.708 406.5 224.5C406.5 189.292 380.98 135.25 349.5 135.25C318.02 135.25 292.5 189.292 292.5 224.5C292.5 225.918 292.541 227.325 292.623 228.719L329.346 273.024C332.264 276.545 330.301 281.693 326.174 282.685C333.294 286.261 341.189 288.25 349.5 288.25Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M201.482 277.012L202.725 278.511C205.005 281.262 208.392 282.854 211.964 282.854H310.47V309.217C310.47 315.845 305.097 321.217 298.47 321.217H201.482V277.012Z"
        fill="black"
        fillOpacity="0.6"
      />
      <path
        d="M127.928 188.275L53.689 276.745H35.6766C31.8629 276.745 29.7782 272.299 32.2174 269.367L113.835 171.272L127.928 188.275Z"
        fill="black"
        fillOpacity="0.6"
      />
      <path
        d="M127.93 188.272L53.6855 276.75V309.217C53.6855 315.845 59.0581 321.217 65.6855 321.217H201.48V277.008L127.93 188.272Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M202.729 278.511L113.824 171.25H239.354C242.927 171.25 246.314 172.842 248.593 175.592L329.352 273.024C332.593 276.935 329.812 282.853 324.732 282.853H211.968C208.396 282.853 205.009 281.262 202.729 278.511Z"
        fill="black"
        fillOpacity="0.4"
      />
      <circle cx="45" cy="142.75" r="31.5" fill="black" fillOpacity="0.1" />
    </svg>
  );
}

export default PlaceholderDefaultIcon;
